module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAiBAMAAAAZjhKBAAAAD1BMVEX///////////////////+Rd1MVAAAABHRSTlMAEJ/PUreMHgAAADZJREFUOMtjYIACZQEG/IDJRYGAChVnAUJGGI4aMdSMcCEAiFBB2BbCLh01ZJAbQqh0wF3CAAC8kR9/AoTr4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/arrows/cursor-left-light-2x.png
// module id = ../../../../../src/assets/images/arrows/cursor-left-light-2x.png
// module chunks = styles